export default __webpack_public_path__ + "static/media/volume-up.e0c4cd18.svg";